import RpIcon from "@/components/RpIcon";
import RouteConstant from "@/constant/RouteConstant";
import { onToggleAccountDrawerOpen } from "@/redux/slices/app";
import { dispatch } from "@/redux/store";
import { getKYCStatusClassName, getKYCStatusDisplay } from "@/utils/userUtils";
import {Stack, Typography, useTheme} from "@mui/material";
import { useConfirm } from "material-ui-confirm";
import { useEffect, useState } from "react";
import {useTranslation} from "react-i18next";
import { useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { KYC_STATUS } from "@/constant/Constant";

export default function KYCCard() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const confirm = useConfirm();
  const { user } = useSelector(state => state.user);
  const theme = useTheme()

  const [kycStatusDisplay, setKycStatusDisplay] = useState('');

  useEffect(() => {
    _initState();
  }, [user]);

  const _initState = () => {
    setKycStatusDisplay(getKYCStatusDisplay(user, t));
  }

  const _onClick = () => {
    if (!_checkBeforeKYC()) return;

    dispatch(onToggleAccountDrawerOpen());
    if (user.hasSubmitKycPreInfo != 1) {
      navigate(RouteConstant.KYC_PRE_FORM);
    } else {
      navigate(RouteConstant.KYC_MAIN);
    }
  }

  const _checkBeforeKYC = () => {
    if (user.mobileBindStatus !== 1) {
      _guideToBindMobile();
      return false;
    }
    return true;
  }

  const _guideToBindMobile = () => {
    confirm({
      title: t('info'),
      description: t('need_mobile_bind_confirm') })
      .then(() => {
        navigate(RouteConstant.USER_SECURITY_MOBILE);
      })
      .catch(() => {
        /* ... */
      });
  }

  let color = '';
  let icon = '';

  switch (user?.kycStatus) {
    case KYC_STATUS.KYC_STATUS_APPROVED:
      color = theme.palette.success.main;
      icon = 'check-circle-thin';
      break;
    case KYC_STATUS.KYC_STATUS_NOT_SUBMIT:
    case KYC_STATUS.KYC_STATUS_SUBMITTED:
      color = theme.palette.warning.main;
      icon = 'info';
      break;
    case KYC_STATUS.KYC_STATUS_REJECT:
    case KYC_STATUS.KYC_STATUS_REJECT_FINAL:
      color = theme.palette.error.main;
      icon = 'close-circle';
      break;
    default:
      color = theme.palette.warning.main;
      icon = 'info';
      break;
  }

  if (!user) return null;

  return (
    <Stack direction={'row'} onClick={_onClick} alignItems="center" gap="4px" sx={{ borderColor: color, borderWidth:'1px', borderStyle:'solid', padding: '2px 6px', borderRadius: '32px', maxWidth: 'fit-content' }}>
      <RpIcon icon={icon} size={16} color={color}/>
      <Typography fontSize={'12px'} sx={{ color: color }}>{kycStatusDisplay}</Typography>
    </Stack>
  );
}
